document.addEventListener("click", (event) => {
  const thumb = event.target.closest("[data-thumb]");
  if (thumb) {
    const main = document.getElementById("gallery-main");
    if (main) {
      main.src = thumb.dataset.thumb;
      main.removeAttribute("srcset");
      main.removeAttribute("sizes");
      document.querySelectorAll("[data-thumb]").forEach((button) => {
        button.setAttribute("aria-current", button === thumb ? "true" : "false");
      });
    }
  }

  const menu = document.querySelector("details.nav-mobile");
  if (menu) {
    if (event.target.closest(".nav-mobile-panel a")) menu.removeAttribute("open");
    if (menu.open && !event.target.closest("details.nav-mobile")) menu.removeAttribute("open");
  }

  const lang = event.target.closest("details.lang");
  document.querySelectorAll("details.lang[open]").forEach((el) => {
    if (el !== lang) el.removeAttribute("open");
  });
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  const drawer = document.getElementById("velora-cart-drawer");
  if (drawer && !drawer.hasAttribute("hidden")) {
    event.preventDefault();
    window.veloraCloseCartDrawer && window.veloraCloseCartDrawer();
    return;
  }
  document.querySelectorAll("details.nav-mobile[open], details.lang[open]").forEach((el) => {
    el.removeAttribute("open");
  });
});

function submitCartUpdate(form) {
  if (!form) return;
  const update = form.querySelector('button[name="update"]');
  if (update && form.requestSubmit) {
    form.requestSubmit(update);
    return;
  }
  form.submit();
}

document.addEventListener("click", (event) => {
  const stepBtn = event.target.closest("[data-qty-step]");
  if (!stepBtn) return;
  const wrap = stepBtn.closest(".line-qty");
  const input = wrap && wrap.querySelector('input[name^="updates"]');
  const form = stepBtn.closest("form");
  if (!input || !form) return;
  const step = Number(stepBtn.getAttribute("data-qty-step")) || 0;
  const current = Math.max(1, Math.floor(Number(input.value) || 1));
  const next = Math.max(1, current + step);
  if (next === current) return;
  input.value = String(next);
  submitCartUpdate(form);
});

document.addEventListener("change", (event) => {
  const input = event.target.closest('input[name^="updates"]');
  if (!input) return;
  const form = input.closest("form");
  if (!form) return;
  const qty = Math.max(1, Math.floor(Number(input.value) || 1));
  input.value = String(qty);
  submitCartUpdate(form);
});

function veloraCartPath() {
  const root = (document.documentElement.getAttribute("data-locale-root") || "").replace(/\/$/, "");
  if (!root || root === "/" || root === "/us") return "/cart";
  return `${root}/cart`;
}

function markGlow30On() {
  try {
    sessionStorage.setItem("velora_glow30_on", "1");
  } catch (err) {}
}

function rewriteProductFormAction(form) {
  if (!form) return;
  const action = form.getAttribute("action") || "";
  if (/\/us\/cart\/add/i.test(action)) {
    form.setAttribute("action", action.replace(/\/us\/cart\/add/i, "/cart/add"));
  }
}

document.querySelectorAll("form.js-product-form").forEach(rewriteProductFormAction);

function bootCartDrawer() {
  const root = document.getElementById("velora-cart-drawer");
  if (!root) return;

  const linesEl = root.querySelector("[data-cart-lines]");
  const footEl = root.querySelector("[data-cart-foot]");
  let lastFocus = null;

  function attr(name) {
    return root.getAttribute(name) || "";
  }

  function formatMoney(cents) {
    const currency = document.documentElement.getAttribute("data-currency") || "EUR";
    const lang = document.documentElement.lang || "fr";
    try {
      return new Intl.NumberFormat(lang, { style: "currency", currency }).format(Number(cents) / 100);
    } catch (err) {
      return (Number(cents) / 100).toFixed(2);
    }
  }

  function hasGlow30(cart) {
    const codes = cart.discount_codes || [];
    if (codes.some((entry) => String(entry.code || "").toUpperCase().includes("GLOW30"))) return true;
    const apps = [].concat(cart.cart_level_discount_applications || [], cart.discount_applications || []);
    if (
      apps.some((app) => {
        const label = String(app.title || app.code || "").toLowerCase();
        return label.includes("glow30") || label.includes("glow 30");
      })
    ) {
      return true;
    }
    const orig = Number(cart.original_total_price || 0);
    const disc = Number(cart.total_discount || 0);
    const total = Number(cart.total_price || 0);
    if (orig > 0 && disc > 0 && Math.round((disc * 100) / orig) === 30) return true;
    if (orig > 0 && total > 0 && Math.round((total * 100) / orig) === 70) return true;
    return false;
  }

  function updateCount(count) {
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = String(count);
      el.classList.toggle("is-empty", !count);
    });
  }

  function close() {
    root.setAttribute("hidden", "");
    document.body.style.removeProperty("overflow");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  window.veloraCloseCartDrawer = close;

  function open() {
    lastFocus = document.activeElement;
    root.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
    const closeBtn = root.querySelector(".drawer-head [data-cart-close]");
    if (closeBtn) closeBtn.focus();
  }

  function render(cart) {
    updateCount(cart.item_count || 0);
    if (!cart.item_count) {
      linesEl.innerHTML =
        '<p class="drawer-empty">' +
        attr("data-empty") +
        ' <a href="' +
        attr("data-mask-url") +
        '">' +
        attr("data-empty-cta") +
        "</a>.</p>";
      footEl.innerHTML = "";
      return;
    }

    const glow = hasGlow30(cart);
    const cartOriginal = cart.original_total_price || 0;
    const cartDiscount = cart.total_discount || 0;
    linesEl.innerHTML = (cart.items || [])
      .map((item) => {
        const img = item.image ? '<img src="' + item.image + '" alt="" width="88" height="88">' : "";
        const original = item.original_line_price || item.final_line_price || 0;
        const rawLine = item.line_price || item.final_line_price || original;
        let off = Math.max(0, original - rawLine);
        if (!off && glow && cartDiscount && cartOriginal) {
          off = Math.round((cartDiscount * original) / cartOriginal);
        }
        const code = glow
          ? '<p class="line-code"><span>' +
            attr("data-code-label") +
            '</span> <span translate="no">GLOW30</span></p>' +
            (off
              ? '<p class="line-save"><span class="cart-discount">' +
                attr("data-off") +
                '</span> <span class="line-save-amount">−' +
                formatMoney(off) +
                "</span></p>"
              : "")
          : "";
        return (
          '<article class="line">' +
          img +
          '<div class="line-body"><strong>' +
          (item.product_title || item.title) +
          '</strong><div class="line-price-row"><div class="qty line-qty" role="group"><button type="button" data-cart-qty="-1" data-key="' +
          item.key +
          '" aria-label="' +
          attr("data-qty-less") +
          '">−</button><input type="number" value="' +
          item.quantity +
          '" min="1" inputmode="numeric" data-cart-qty-input data-key="' +
          item.key +
          '"><button type="button" data-cart-qty="1" data-key="' +
          item.key +
          '" aria-label="' +
          attr("data-qty-more") +
          '">+</button></div><strong class="line-amount">' +
          formatMoney(original) +
          '</strong></div><div class="line-meta"><button type="button" class="drawer-remove" data-cart-remove data-key="' +
          item.key +
          '">' +
          attr("data-remove") +
          '</button><div class="line-total">' +
          code +
          "</div></div></div></article>"
        );
      })
      .join("");

    const checkout = attr("data-discount") + "?redirect=" + encodeURIComponent("/checkout");
    footEl.innerHTML =
      '<div class="totals">' +
      (glow
        ? '<div><span translate="no">GLOW30</span><strong>' + attr("data-off") + "</strong></div>"
        : "") +
      "<div><span>" +
      attr("data-subtotal") +
      "</span><strong>" +
      formatMoney(cart.total_price) +
      "</strong></div><div><span>" +
      attr("data-shipping") +
      '</span></div></div><a class="btn btn-primary cart-checkout" href="' +
      checkout +
      '">' +
      attr("data-checkout-label") +
      '</a><a class="drawer-view" href="' +
      attr("data-cart-url") +
      '">' +
      attr("data-view") +
      "</a>";
  }

  function loadCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then((res) => {
      if (!res.ok) throw new Error("cart");
      return res.json();
    });
  }

  function applyGlow30() {
    markGlow30On();
    return fetch(attr("data-discount") || "/discount/GLOW30", { credentials: "same-origin" });
  }

  function refresh(andOpen) {
    return loadCart()
      .then((cart) => {
        if (hasGlow30(cart)) return cart;
        return applyGlow30()
          .catch(() => null)
          .then(() => loadCart());
      })
      .then((cart) => {
        render(cart);
        if (andOpen) open();
        return cart;
      });
  }

  function changeQty(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
    }).then((res) => {
      if (!res.ok) throw new Error("change");
      return refresh(false);
    });
  }

  function addFromForm(form) {
    rewriteProductFormAction(form);
    const body = new FormData(form);
    let url = form.getAttribute("action") || "/cart/add.js";
    url = url.replace(/\/us\/cart\/add/i, "/cart/add").replace(/\/cart\/add$/i, "/cart/add.js");
    if (!/\.js(\?|$)/.test(url)) url = "/cart/add.js";
    return fetch(url, { method: "POST", body, credentials: "same-origin" }).then((res) => {
      if (!res.ok) throw new Error("add");
      return res.json();
    });
  }

  root.addEventListener("click", (event) => {
    if (event.target.closest("[data-cart-close]")) {
      event.preventDefault();
      close();
      return;
    }
    const remove = event.target.closest("[data-cart-remove]");
    if (remove) {
      event.preventDefault();
      changeQty(remove.getAttribute("data-key"), 0);
      return;
    }
    const step = event.target.closest("[data-cart-qty]");
    if (step) {
      event.preventDefault();
      const key = step.getAttribute("data-key");
      const input = root.querySelector('[data-cart-qty-input][data-key="' + key + '"]');
      const current = Math.max(1, Math.floor(Number(input && input.value) || 1));
      const next = Math.max(0, current + (Number(step.getAttribute("data-cart-qty")) || 0));
      changeQty(key, next);
    }
  });

  root.addEventListener("change", (event) => {
    const input = event.target.closest("[data-cart-qty-input]");
    if (!input) return;
    const qty = Math.max(1, Math.floor(Number(input.value) || 1));
    changeQty(input.getAttribute("data-key"), qty);
  });

  document.addEventListener(
    "click",
    (event) => {
      const trigger = event.target.closest("[data-cart-open]");
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      refresh(true).catch(() => {
        open();
      });
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute("action") || "";
      const isAdd =
        form.classList.contains("js-product-form") ||
        (/\/cart\/add/i.test(action) && form.querySelector('input[name="id"]'));
      if (!isAdd) return;
      rewriteProductFormAction(form);
      event.preventDefault();
      addFromForm(form)
        .then(() => refresh(true))
        .catch(() => {
          loadCart()
            .then((cart) => {
              render(cart);
              open();
            })
            .catch(() => {
              form.submit();
            });
        });
    },
    true
  );
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootCartDrawer);
else bootCartDrawer();
